import {
  ButtonType,
  CaesarsButton,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

import {OCRMOffer, OCRMStatus} from 'models/Offer';

import OfferDetailsButtonSpacing from './OfferDetailsButtonSpacing';
import OfferDetailsButtonsWrapper from './OfferDetailsButtonsWrapper';

interface OCRMButtonsPropTypes {
  offer: OCRMOffer;
  closeSlideFlyout: () => void;
  acceptOCRMOfferPress: () => void;
  isAcceptError: boolean;
}

const OCRMButtons: React.FC<OCRMButtonsPropTypes> = ({
  offer,
  closeSlideFlyout,
  acceptOCRMOfferPress,
  isAcceptError,
}) => {
  const isDesktop = useIsDesktop();
  const showAcceptButton =
    !isAcceptError &&
    [OCRMStatus.ACTIVE, OCRMStatus.OFFERED].includes(
      offer.status as OCRMStatus
    );

  const closeButton = (
    <CaesarsButton
      type={showAcceptButton ? ButtonType.TEXT_CTA : undefined}
      title="Close"
      onPress={closeSlideFlyout}
      isFullWidth={!isDesktop}
    />
  );

  if (showAcceptButton) {
    return (
      <OfferDetailsButtonsWrapper>
        <View
          flexDirection={isDesktop ? 'row' : 'column-reverse'}
          alignItems={isDesktop ? 'flex-start' : 'center'}>
          {closeButton}
          <OfferDetailsButtonSpacing />
          <CaesarsButton
            title="Accept Offer"
            onPress={acceptOCRMOfferPress}
            isFullWidth={!isDesktop}
          />
        </View>
      </OfferDetailsButtonsWrapper>
    );
  }

  return (
    <OfferDetailsButtonsWrapper>
      <View>{closeButton}</View>
    </OfferDetailsButtonsWrapper>
  );
};

export default OCRMButtons;
